// Действия вкладки "Функционал"
function actionAct(obj, form, data, story) {
	switch (obj.action) {
		case 'click':
			form.fncClick(obj.id, story.current.info);
			break;
		case 'close':
			form.func();
			break;
		case 'home':
			form.fncHome();
			break;
		case 'up':
			form.fncUp();
			break;
		default:
			alert('[Функционал] Действие не определено');
	}
}

export default actionAct;
